import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../App';
import { Search, User, Shield, Store, Scissors } from 'lucide-react';

const ROLE_ICONS = { MASTER_ADMIN: Shield, ORG_OWNER: Shield, ORG_STAFF: User, STORE_OWNER: Store, STORE_STAFF: User, GROOMER: Scissors, CUSTOMER: User };
const ROLE_COLORS = { MASTER_ADMIN: '#EF4444', ORG_OWNER: '#8B5CF6', ORG_STAFF: '#6366F1', STORE_OWNER: '#FF8C42', STORE_STAFF: '#F59E0B', GROOMER: '#20B2AA', CUSTOMER: '#6B7280' };

export default function DenUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roleFilter, setRoleFilter] = useState('');

  useEffect(() => {
    const params = roleFilter ? `?role=${roleFilter}` : '';
    apiFetch(`/api/admin/users${params}`).then(u => { setUsers(u); setLoading(false); }).catch(() => setLoading(false));
  }, [roleFilter]);

  const ROLES = ['', 'MASTER_ADMIN', 'ORG_OWNER', 'STORE_OWNER', 'GROOMER', 'CUSTOMER'];

  return (
    <div data-testid="den-users">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <h1 className="font-outfit text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>Users & Staff</h1>
        <div className="flex gap-2 overflow-x-auto no-scrollbar">
          {ROLES.map(r => (
            <button
              key={r}
              onClick={() => { setRoleFilter(r); setLoading(true); }}
              data-testid={`filter-role-${r || 'all'}`}
              className={`px-3 py-1.5 rounded-xl text-xs font-semibold shrink-0 transition-all ${roleFilter === r ? 'bg-petfolk-orange text-white' : ''}`}
              style={{ color: roleFilter !== r ? 'var(--text-secondary)' : undefined }}
            >
              {r || 'All'}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="space-y-3">{[1,2,3,4].map(i => <div key={i} className="skeleton h-16 rounded-2xl" />)}</div>
      ) : (
        <div className="space-y-2">
          {users.map(u => {
            const Icon = ROLE_ICONS[u.role] || User;
            return (
              <div key={u.id} className="petfolk-card p-4 flex items-center gap-4" data-testid={`user-${u.id}`}>
                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${ROLE_COLORS[u.role] || '#6B7280'}15` }}>
                  <Icon size={18} style={{ color: ROLE_COLORS[u.role] || '#6B7280' }} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-sm truncate" style={{ color: 'var(--text-primary)' }}>{u.name || 'Unnamed'}</p>
                  <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>{u.phone} {u.email && `• ${u.email}`}</p>
                </div>
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full" style={{ background: `${ROLE_COLORS[u.role] || '#6B7280'}15`, color: ROLE_COLORS[u.role] || '#6B7280' }}>
                  {u.role?.replace('_', ' ')}
                </span>
              </div>
            );
          })}
        </div>
      )}

      <div className="mt-4 text-center text-sm" style={{ color: 'var(--text-secondary)' }}>
        {users.length} users total
      </div>
    </div>
  );
}
